import api from './api';

const sidebarPrefsService = {
  get: async () => {
    const response = await api.get('/users/me/sidebar-prefs');
    return response.data;
  },
  save: async (order) => {
    const response = await api.put('/users/me/sidebar-prefs', { order });
    return response.data;
  }
};

export default sidebarPrefsService;
